import { AssetsEnum } from './assets';
import { PaymentMethod } from '../models';

const PaymentDictionary: Record<string, PaymentMethod> = {
  [AssetsEnum.USD]: {
    symbol: AssetsEnum.USD,
    name: 'Debit Card',
    isCrypto: false,
  },
  [AssetsEnum.ETH]: {
    symbol: AssetsEnum.ETH,
    name: 'Ethereum',
    isCrypto: true,
  },
  [AssetsEnum.BTC]: {
    symbol: AssetsEnum.BTC,
    name: 'Bitcoin',
    isCrypto: true,
  },
  [AssetsEnum.USDTTRC20]: {
    symbol: AssetsEnum.USDTTRC20,
    name: 'USDT (TRC20)',
    isCrypto: true,
  },
  [AssetsEnum.USDTERC20]: {
    symbol: AssetsEnum.USDTERC20,
    name: 'USD Tether (ERC20)',
    isCrypto: true,
  },
  [AssetsEnum.ADA]: {
    symbol: AssetsEnum.ADA,
    name: 'Cardano',
    isCrypto: true,
  },
  [AssetsEnum.SOL]: {
    symbol: AssetsEnum.SOL,
    name: 'Solana',
    isCrypto: true,
  },
  [AssetsEnum.BTG]: {
    symbol: AssetsEnum.BTG,
    name: 'Bitcoin Gold',
    isCrypto: true,
  },
  [AssetsEnum.XVG]: {
    symbol: AssetsEnum.XVG,
    name: 'Verge',
    isCrypto: true,
  },
  [AssetsEnum.LTC]: {
    symbol: AssetsEnum.LTC,
    name: 'Litecoin',
    isCrypto: true,
  },
  [AssetsEnum.BCH]: {
    symbol: AssetsEnum.BCH,
    name: 'Bitcoin Cash',
    isCrypto: true,
  },
  [AssetsEnum.QTUM]: {
    symbol: AssetsEnum.QTUM,
    name: 'Qtum',
    isCrypto: true,
  },
  [AssetsEnum.XLM]: {
    symbol: AssetsEnum.XLM,
    name: 'Stellar Lumens',
    isCrypto: true,
  },
  [AssetsEnum.XRP]: {
    symbol: AssetsEnum.XRP,
    name: 'Ripple',
    isCrypto: true,
  },
  [AssetsEnum.DOGE]: {
    symbol: AssetsEnum.DOGE,
    name: 'Dogecoin',
    isCrypto: true,
  },
  [AssetsEnum.TRX]: {
    symbol: AssetsEnum.TRX,
    name: 'TRON',
    isCrypto: true,
  },
  [AssetsEnum.USDC]: {
    symbol: AssetsEnum.USDC,
    name: 'USD Coin',
    isCrypto: true,
  },
  [AssetsEnum.KMD]: {
    symbol: AssetsEnum.KMD,
    name: 'Komodo',
    isCrypto: true,
  },
  [AssetsEnum.BAT]: {
    symbol: AssetsEnum.BAT,
    name: 'Basic Attention Token',
    isCrypto: true,
  },
  [AssetsEnum.WAVES]: {
    symbol: AssetsEnum.WAVES,
    name: 'Waves',
    isCrypto: true,
  },
  [AssetsEnum.TUSD]: {
    symbol: AssetsEnum.TUSD,
    name: 'TrueUSD',
    isCrypto: true,
  },
  [AssetsEnum.ZEN]: {
    symbol: AssetsEnum.ZEN,
    name: 'Horizen',
    isCrypto: true,
  },
  [AssetsEnum.FUN]: {
    symbol: AssetsEnum.FUN,
    name: 'FunFair',
    isCrypto: true,
  },
  [AssetsEnum.RVN]: {
    symbol: AssetsEnum.RVN,
    name: 'Ravencoin',
    isCrypto: true,
  },
  [AssetsEnum.BEL]: {
    symbol: AssetsEnum.BEL,
    name: 'Bella Protocol',
    isCrypto: true,
  },
  [AssetsEnum.C98]: {
    symbol: AssetsEnum.C98,
    name: 'Coin98',
    isCrypto: true,
  },
  [AssetsEnum.DAI]: {
    symbol: AssetsEnum.DAI,
    name: 'Dai',
    isCrypto: true,
  },
  [AssetsEnum.ZIL]: {
    symbol: AssetsEnum.ZIL,
    name: 'Zilliqa',
    isCrypto: true,
  },
  [AssetsEnum.ZEC]: {
    symbol: AssetsEnum.ZEC,
    name: 'Zcash',
    isCrypto: true,
  },
  [AssetsEnum.LUNA]: {
    symbol: AssetsEnum.LUNA,
    name: 'Terra',
    isCrypto: true,
  },
  [AssetsEnum.AVAX]: {
    symbol: AssetsEnum.AVAX,
    name: 'Avalanche',
    isCrypto: true,
  },
};

const newPaymentMethod = (symbol: string) => {
  return {
    symbol,
    name: symbol,
    isCrypto: true,
  };
};

export { PaymentDictionary, newPaymentMethod };
